<template>
  <div ref="load" class="loading active">
    <div class="loading__content">
      <div class="loading__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="
            margin: auto;
            background: transparent;
            display: block;
            shape-rendering: auto;
          "
          width="100px"
          height="90px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <defs>
            <clipPath id="ldio-9w2svo6awvh-cp">
              <path
                d="M57.6,64.3c6.1,5.4,9.9,13.2,9.9,22c0,0.2,0,0.5,0,0.7h44c0-0.2,0-0.5,0-0.7c0-40.3-32.5-73-72.7-73.3v20.1 l9.5,25.6C48.4,58.8,54.9,61.9,57.6,64.3"
              />
            </clipPath>
          </defs>
          <path
            fill="#ec3faa"
            d="M54.6,66c-1.2,0-2.2-0.8-2.5-2c-0.3-1.4,0.6-2.7,2-2.9l0.3-0.1c0.3-0.2,1.3-1.6,1.5-5.8 c0.1-4.4-0.8-9.9-2.5-15.6c-1.7-5.7-4.1-10.8-6.6-14.4c-2.4-3.4-4-4.1-4.4-4l-0.3,0.1c-1.3,0.5-2.7-0.1-3.3-1.3 c-0.5-1.3,0.1-2.7,1.3-3.3l0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c2.2-0.7,5.7-0.2,10,5.9c2.8,4,5.4,9.6,7.3,15.8 c1.9,6.2,2.8,12.3,2.7,17.2c-0.2,7.4-2.9,9.8-5.1,10.4c-0.1,0-0.2,0-0.3,0.1L55.1,66C54.9,66,54.8,66,54.6,66z"
            transform="translate(0 0.329161)"
          >
            <animateTransform
              attributeName="transform"
              type="translate"
              keyTimes="0;0.5;1"
              values="0,0;0,3;0 0"
              dur="0.5847953216374269s"
              repeatCount="indefinite"
            />
          </path>
          <g
            id="ldio-9w2svo6awvh-rainbow"
            clip-path="url(#ldio-9w2svo6awvh-cp)"
          >
            <path
              fill="#005baa"
              stroke-width="0"
              d="M 95 85Q 97.45 88.17 97.02 91.32T 93.55 96.97T 89.51 101.88T 89.27 108.24T 88.12 114.77T 82.43 118.16T 76.56 120.63T 73.4 126.15T 69.35 131.4T 62.73 131.75T 56.39 131.22T 51.03 134.64T 45 137.4T 38.97 134.64T 33.61 131.22T 27.27 131.75T 20.65 131.4T 16.6 126.15T 13.44 120.63T 7.57 118.16T 1.88 114.77T 0.73 108.24T 0.49 101.88T -3.55 96.97T -7.02 91.32T -5 85T -2.25 79.26T -3.55 73.03T -3.99 66.42T 0.73 61.76T 5.83 57.96T 7.57 51.84T 10.25 45.78T 16.6 43.85T 22.88 42.85T 27.27 38.25T 32.46 34.12T 38.97 35.36T 45 37.4T 51.03 35.36T 57.54 34.12T 62.73 38.25T 67.12 42.85T 73.4 43.85T 79.75 45.78T 82.43 51.84T 84.17 57.96T 89.27 61.76T 93.99 66.42T 93.55 73.03T 92.25 79.26T 95 85ZM 72.5 85Q 71.81 83.38 71.7 81.76T 71.7 78.42T 71.27 75.04T 69.35 72.22T 67.14 69.72T 65.58 66.76T 63.63 63.97T 60.62 62.37T 57.5 61.18T 54.75 59.29T 51.72 57.72T 48.31 57.7T 45 58.1T 41.69 57.7T 38.28 57.72T 35.25 59.29T 32.5 61.18T 29.38 62.37T 26.37 63.97T 24.42 66.76T 22.86 69.72T 20.65 72.22T 18.73 75.04T 18.3 78.42T 18.3 81.76T 17.5 85T 17.1 88.39T 18.3 91.58T 19.85 94.54T 20.65 97.78T 21.87 100.96T 24.42 103.24T 27.16 105.13T 29.38 107.63T 31.94 109.88T 35.25 110.71T 38.56 111.12T 41.69 112.3T 45 113.1T 48.31 112.3T 51.44 111.12T 54.75 110.71T 58.06 109.88T 60.62 107.63T 62.84 105.13T 65.58 103.24T 68.13 100.96T 69.35 97.78T 70.15 94.54T 71.7 91.58T 72.9 88.39Z"
              transform="rotate(24.6657 45 85)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 45 85;27.692307692307693 45 85"
                dur="0.29239766081871343s"
                repeatCount="indefinite"
                keyTimes="0;1"
              />
            </path>
            <path
              fill="#e9ed9a"
              stroke-width="0"
              d="M 87.5 85Q 89.93 88.21 89.44 91.39T 85.78 96.97T 81.48 101.66T 80.75 107.98T 78.93 114.4T 72.83 117.12T 66.68 118.73T 62.66 123.66T 57.65 128.08T 51.05 127.07T 45 125.1T 38.95 127.07T 32.35 128.08T 27.34 123.66T 23.32 118.73T 17.17 117.12T 11.07 114.4T 9.25 107.98T 8.52 101.66T 4.22 96.97T 0.56 91.39T 2.5 85T 5.31 79.29T 4.22 73.03T 4.16 66.35T 9.25 62.02T 14.69 58.74T 17.17 52.88T 20.73 47.23T 27.34 46.34T 33.7 46.52T 38.95 42.93T 45 40.1T 51.05 42.93T 56.3 46.52T 62.66 46.34T 69.27 47.23T 72.83 52.88T 75.31 58.74T 80.75 62.02T 85.84 66.35T 85.78 73.03T 84.69 79.29T 87.5 85ZM 72.5 85Q 71.8 83.08 71.63 81.17T 71.39 77.25T 70.56 73.33T 68.13 70.13T 65.33 67.38T 63.01 64.22T 60.19 61.36T 56.42 59.99T 52.58 59.19T 48.91 57.78T 45 56.9T 41.09 57.78T 37.42 59.19T 33.58 59.99T 29.81 61.36T 26.99 64.22T 24.67 67.38T 21.87 70.13T 19.44 73.33T 18.61 77.25T 18.37 81.17T 17.5 85T 17.19 89T 18.61 92.75T 20.53 96.17T 21.87 99.87T 23.76 103.4T 26.99 105.78T 30.46 107.63T 33.58 110.01T 37.08 111.96T 41.09 112.22T 45 111.9T 48.91 112.22T 52.92 111.96T 56.42 110.01T 59.54 107.63T 63.01 105.78T 66.24 103.4T 68.13 99.87T 69.47 96.17T 71.39 92.75T 72.81 89Z"
              transform="rotate(30.9318 45 85)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 45 85;32.72727272727273 45 85"
                dur="0.5847953216374269s"
                repeatCount="indefinite"
                keyTimes="0;1"
              />
            </path>
            <path
              fill="#f37053"
              stroke-width="0"
              d="M 81 85Q 82.76 88.3 82.23 91.56T 78.83 97.31T 74.62 102.1T 72.58 108.14T 69.3 113.96T 63 116.18T 56.7 117.14T 51.25 120.45T 45 122.8T 38.75 120.45T 33.3 117.14T 27 116.18T 20.7 113.96T 17.42 108.14T 15.38 102.1T 11.17 97.31T 7.77 91.56T 9 85T 11.32 79.06T 11.17 72.69T 12.26 66.1T 17.42 61.86T 23.02 58.8T 27 53.82T 32.07 49.48T 38.75 49.55T 45 50.8T 51.25 49.55T 57.93 49.48T 63 53.82T 66.98 58.8T 72.58 61.86T 77.74 66.1T 78.83 72.69T 78.68 79.06T 81 85ZM 72.5 85Q 71.76 82.66 71.49 80.33T 70.84 75.59T 69.34 70.95T 66.07 67.32T 62.29 64.39T 58.75 61.18T 54.61 58.59T 49.78 57.92T 45 58.1T 40.22 57.92T 35.39 58.59T 31.25 61.18T 27.71 64.39T 23.93 67.32T 20.66 70.95T 19.16 75.59T 18.51 80.33T 17.5 85T 17.33 89.88T 19.16 94.41T 21.7 98.45T 23.93 102.68T 26.94 106.53T 31.25 108.82T 35.8 110.28T 40.22 112.08T 45 113.1T 49.78 112.08T 54.2 110.28T 58.75 108.82T 63.06 106.53T 66.07 102.68T 68.3 98.45T 70.84 94.41T 72.67 89.88Z"
              transform="rotate(35.6283 45 85)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 45 85;40 45 85"
                dur="0.29239766081871343s"
                repeatCount="indefinite"
                keyTimes="0;1"
              />
            </path>
            <path
              fill="#94d6da"
              stroke-width="0"
              d="M 75.5 85Q 76.57 88.56 75.91 92.05T 72.48 98.23T 67.91 103.27T 64.02 108.85T 58.75 113.56T 51.79 114.74T 45 114.3T 38.21 114.74T 31.25 113.56T 25.98 108.85T 22.09 103.27T 17.52 98.23T 14.09 92.05T 14.5 85T 16.43 78.48T 17.52 71.77T 20.22 65.24T 25.98 61.15T 32.29 58.6T 38.21 55.26T 45 53.3T 51.79 55.26T 57.71 58.6T 64.02 61.15T 69.78 65.24T 72.48 71.77T 73.57 78.48T 75.5 85ZM 71 85Q 70.2 82.16 69.76 79.35T 68.43 73.72T 65.8 68.42T 61.21 64.67T 56.02 62.12T 50.79 59.65T 45 58.4T 39.21 59.65T 33.98 62.12T 28.79 64.67T 24.2 68.42T 21.57 73.72T 20.24 79.35T 19 85T 19.07 90.92T 21.57 96.28T 25.14 100.84T 28.79 105.33T 33.46 108.97T 39.21 110.35T 45 110.4T 50.79 110.35T 56.54 108.97T 61.21 105.33T 64.86 100.84T 68.43 96.28T 70.93 90.92Z"
              transform="rotate(48.6072 45 85)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 45 85;51.42857142857143 45 85"
                dur="0.5847953216374269s"
                repeatCount="indefinite"
                keyTimes="0;1"
              />
            </path>
          </g>
          <path
            fill="#ec3faa"
            d="M57.1,63.3c-0.1-1.4-1.4-2.4-2.7-2.2c-1.8,0.2-7.3-6.1-11-18.4c-3.7-12.2-2.6-20.6-1-21.4 c1.2-0.6,1.7-2.2,1-3.4c-0.6-1.2-2.2-1.7-3.4-1c-1.4,0.7-2.4,2.1-3.1,3.9c-4.5,2.2-24.3,12-32.3,15.3c-1.8,0.8-3,2.5-3.1,4.4 c-0.4,10.6,2.6,20.2,8.8,29c1.1,1.6,3.1,2.4,5.1,2.1l28.5-6.3c-1.8-1.4-3.3-3-4.4-4.8c-0.2-0.3-0.6-0.5-1-0.4l-1.1,0.3 C35.5,61,33.5,59.9,33,58c-0.5-1.9,0.7-3.8,2.5-4.3l0.9-0.3c0.4-0.1,0.7-0.5,0.6-0.9l0,0c-0.1-0.5-0.6-0.9-1.1-0.7l-8.2,2.5 c-1.9,0.6-3.9-0.5-4.4-2.5c-0.5-1.9,0.7-3.8,2.5-4.3l9.5-2.9c0.4-0.1,0.6-0.5,0.6-0.9c-0.1-2.6,0.1-5.1,0.7-7.4 c0.5,2.6,1.1,5.3,1.9,7.9C41.8,54.8,48,66,54.3,66c0.2,0,0.4,0,0.5,0C56.2,65.9,57.2,64.6,57.1,63.3z"
            transform="translate(0 0.329161)"
          >
            <animateTransform
              attributeName="transform"
              type="translate"
              keyTimes="0;0.5;1"
              values="0 0;0 3;0 0"
              dur="0.5847953216374269s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
      <p v-if="msg" class="loading__msg">{{ msg }}</p>
      <p v-if="description" class="loading__description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BucketLoading',
  props: {
    msg: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* Loading */
.loading {
  background-color: rgba(242, 242, 246, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 150px;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
  display: none;
  height: 100%;
  width: 100%;

  &.active {
    display: block;
    visibility: visible;
  }

  .loading__content {
    position: relative;
    text-align: center;
    right: 0;
    color: #444;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    .loading__msg {
      font-weight: bold;
      font-size: 16px;
      max-width: 200px;
      margin: 0 auto;
    }

    .loading__description {
      max-width: 300px;
      margin: 8px auto;
      font-size: 14px;
      font-style: italic;
    }
  }
}
</style>
